import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

const ClientCreate = ({open, close, model, ...rest}) => {
  const app = React.useContext(AppContext)
  const {  recall, setRecall } = app
  const { bundles } = app.bundles
  const { create, update, metrics } = app.clients
  const bundle =  model?bundles.find(b => b.name == model.bundle):null
  const publicityUniqueKeywords = model && model.publicityUniqueKeywords && model.publicityUniqueKeywords != ""?model.publicityUniqueKeywords.split(","):[]
  const scope = model?"Guardar":"Crear"
  const submit = d=>  model?update(d):create(d)
  const title = scope+" Cliente"
  
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={submit}
        obj={{name:'',  bundle:'', prefix:'', publicityUniqueKeywords:''}}
        types={{name:'text', bundle:'select', prefix:'text', publicityUniqueKeywords: 'tag'}}
        labels={{name:'nombre', bundle:'paquete', prefix:'prefijo', publicityUniqueKeywords: 'publicidad - palabras clave'}}
        options={{bundle:bundles.map(b => {return{value:b.id,label:b.name}})}} 
        changed={model?{...model, publicityUniqueKeywords, bundle:bundle?bundle.id:bundle}:{}}
      />
      <Button onClick={() => {setRecall(true);close()}}>{scope}</Button>
    </Dialog>
  )
}
export default ClientCreate